import React, { useState } from 'react';
import noop from 'lodash/noop';
import lockIcon from 'images/icons/big9/lock.svg';

const renderTextInput = ({
    name,
    value,
    onChange,
    placeholder,
    label,
    disabled = false,
    suffix,
    type,
    onBlur = noop,
    onFocus = noop,
    showFormErrors = noop,
}) => {
    const [focused, setFocused] = useState(false);

    const onBlurHandler = () => {
        showFormErrors(true);
        onBlur();
    };

    const displayWithSuffix = () => {
        setFocused(true);
        onFocus();
    };
    const removeSuffix = () => {
        setFocused(false);
        onBlurHandler();
    };

    return (
        <input
            name={name}
            type={type}
            value={suffix && !focused ? value + suffix : value}
            onChange={onChange}
            placeholder={placeholder || label}
            className="sk-form-input bottom-indent-sm-md"
            disabled={disabled}
            onFocus={suffix ? displayWithSuffix : onFocus}
            onBlur={suffix ? removeSuffix : onBlurHandler}
        />
    );
};

const renderSelect = ({ onChange, value, options }) => (
    <select
        onChange={onChange}
        value={value}
        className="sk-form-input sk-select-arrow bottom-indent-sm-md"
    >
        {options.map(([key, label]) => (
            <option key={key} value={key}>
                {label}
            </option>
        ))}
    </select>
);

const renderCustomSelect = ({
    placeholder,
    label,
    name,
    value,
    callback,
    dropdown,
    options,
    showFormErrors = noop,
}) => {
    const findValue = () => {
        const option = options.find((option) => option.includes(Number(value)));
        return option ? option[1] : '';
    };
    return (
        <>
            <input
                type={'text'}
                name={name}
                placeholder={placeholder || label}
                className="sk-form-input sk-select-arrow bottom-indent-sm-md"
                value={value && findValue(options)}
                onClick={(e) => {
                    callback(e);
                    showFormErrors(true);
                }}
                readOnly
            />
            {dropdown}
        </>
    );
};

const renderCounterInput = ({
    values,
    errors,
    setter,
    label,
    showFormErrors,
}) => {
    // const poolAmountExceed =
    //     (values.shareNumber.get() + 1) * values.sharePrice.get() <=
    //     MAX_POOL_AMOUNT;
    // const maxSharesReached = values.shareNumber.get() < values.maxShares.get();
    // const canBuyMoreShares = !poolAmountExceed && !maxSharesReached;

    return (
        <div className="sk-form-input flex space-between align-center bottom-indent-sm-md">
            <div className="flex">
                <button
                    className="sk-shares-button"
                    onClick={() => {
                        showFormErrors();

                        if (values['shareNumber'].get() > 0) {
                            setter({
                                ['shareNumber']:
                                    values['shareNumber'].get() - 1,
                            });
                        }
                    }}
                >
                    -
                </button>
                <input
                    className="sk-number-input"
                    type="number"
                    value={values['shareNumber'].get()}
                    onChange={(e) => setter({ [name]: e.target.value })}
                />
                {values['shareNumber'].get() < values['maxShares'].get() && (
                    <button
                        className="sk-shares-button"
                        onClick={() => {
                            showFormErrors();

                            if (
                                values['shareNumber'].get() >= 0 &&
                                !errors['shareNumber'].get()
                            ) {
                                setter({
                                    ['shareNumber']:
                                        values['shareNumber'].get() + 1,
                                });
                            }
                        }}
                    >
                        +
                    </button>
                )}
            </div>
            <span className="sk-input-number-name">
                {label}{' '}
                {values.shareNumber.get() * values.sharePrice.get() || 0} kr.
            </span>
        </div>
    );
};

const renderTextArea = ({
    name,
    value,
    onChange,
    placeholder,
    label,
    maxLength,
}) => (
    <textarea
        name={name}
        onChange={onChange}
        placeholder={placeholder || label}
        className="sk-form-textarea"
        maxLength={maxLength}
        value={value}
    />
);

const typeMap = {
    text: renderTextInput,
    number: renderTextInput,
    select: renderSelect,
    customSelect: renderCustomSelect,
    counter: renderCounterInput,
    textArea: renderTextArea,
};

const Input = ({
    name,
    type,
    values,
    label,
    placeholder,
    errors,
    options,
    selected,
    setter = noop,
    customInput,
    callback = () => {},
    dropdown,
    disabled = false,
    suffix,
    inputTip,
    maxLength,
    showErrors,
    onBlur = noop,
    onFocus = noop,
    showFormErrors = noop,
    locked = false,
    onChangeValue,
}) => {
    const value = values[name].get();
    const error = errors[name].get();

    const onChange = (e) => {
        setter({ [name]: e.target.value });
        onChangeValue && onChangeValue(e.target.value);
        showFormErrors(true);
    };

    const renderInput = typeMap[type] || renderTextInput;
    const inputProps = {
        onChange,
        onBlur,
        onFocus,
        name,
        value,
        type,
        placeholder,
        label,
        options,
        selected,
        errors,
        values,
        setter,
        callback,
        dropdown,
        disabled,
        suffix,
        maxLength,
        showFormErrors,
    };

    return (
        <div className={`sk-input-wrapper`}>
            <label
                className={`sk-form-label ${
                    label === 'Klubnavn' ? 'mt-0' : ''
                }`}
            >
                {label}
            </label>
            {customInput || renderInput(inputProps)}
            {locked && (
                <img
                    src={lockIcon}
                    alt={'locked'}
                    className="sk-lock-icon fade-in"
                />
            )}
            {showErrors &&
                error &&
                !inputTip && (
                    <span className="sk-field-error sk-field-error-positioned fade-in">
                        {error}
                    </span>
                )}
            {inputTip && <span className="sk-field-tip">{inputTip}</span>}
        </div>
    );
};

export default Input;
